// extracted by mini-css-extract-plugin
module.exports = {"container":"i_CM","body":"i_CN","section":"i_CO","meta":"i_CP","meta-list":"i_CQ","meta-item":"i_CR","intro":"i_CS","footer-legal":"i_CT"};